import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import type { UserPreferencesModel } from '@/models';
import { getUserPreferences, saveUserPreferences } from '@/services/userPreferenceService';

export const useUserPreferenceStore = defineStore('userPreference', () => {
  const hasLoadedPreferences = ref(false);

  const preferences = ref<UserPreferencesModel>({
    currentCollectionId: 0,
  });

  const currentCollectionId = computed(() => preferences.value.currentCollectionId || 0);

  async function loadPreferences(force: boolean = false) {
    if (force || !hasLoadedPreferences.value) {
      preferences.value = await getUserPreferences();

      hasLoadedPreferences.value = true;
    }
  }

  async function setCurrentCollection(collectionId: Number) {
    preferences.value.currentCollectionId = collectionId;
    await savePreferences();
  }

  async function savePreferences() {
    await saveUserPreferences(preferences.value);
  }

  return {
    preferences,
    currentCollectionId,
    loadPreferences,
    savePreferences,
    setCurrentCollection,
  }
});
